module.exports = __webpack_public_path__ + "static/media/blinds.c31ebf68.svg";